import { openLotteryVideoStream } from "@/lotteries/streaming/stream";
import { nextTick, Ref, ref } from "vue";

export const isLiveStreamOpen = ref(false);

let currentStream = null;

export const useLotteryStream = (el: Ref<HTMLElement>) => {
    const streamPlaying = ref<boolean>(false);
    let close = null;

    const obj = {
        start,
        stop,
        streamPlaying,
    };

    function start() {
        if (currentStream) {
            currentStream.stop();
        }
        currentStream = obj;
        streamPlaying.value = true;
        nextTick(async () => {
            try {
                close = (await openLotteryVideoStream(el.value)).close;
            } catch (e) {
                streamPlaying.value = false;
            }
        });
    }
    function stop() {
        if (close) {
            close();
            streamPlaying.value = false;
        }
    }

    return obj;
};
